import {Component, DoCheck, Input, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {LookupService} from '../../common/service/lookup.service';
import {PlanModelService} from '../../common/service/plan-model.service';
import {NgClass} from '@angular/common';
import {equals} from '../../common/service/data-util';
import {ParentPlanType} from '../../common/models/parent-plan-type.model';

export interface BurdenedAffectedTenure {
    affectedTenure: any;
    affectedTenureLot: any;
}

interface UiOption {
    burdenedAffectedTenure: BurdenedAffectedTenure;
    selected: boolean;
}

@Component({
    selector: 'burdens-affected-tenure',
    imports: [NgClass, FormsModule],
    templateUrl: './burdens-affected-tenure.component.html',
    styleUrl: './burdens-affected-tenure.component.scss'
})
export class BurdensAffectedTenureComponent implements OnInit, DoCheck {
    @Input()
    model: any;
    @Input()
    submitted: boolean;
    parentPlanTypeLookups: ParentPlanType[];
    options: UiOption[] = [];

    constructor(
        private lookupService: LookupService,
        private planModelService: PlanModelService
    ) {}

    ngOnInit(): void {
        this.parentPlanTypeLookups = this.lookupService.getLookups('parentPlanType');

        console.info('this.model:', this.model);
        this.options.push(
            ...this.planModelService.getModel().formerTenures.reduce((acc, tenure) => {
                if (tenure.lots && tenure.lots.length) {
                    acc.push(
                        ...tenure.lots.map(lot => {
                            const burdenedAffectedTenure = this.model.find(v => equals(v.affectedTenure, tenure) && equals(v.affectedTenureLot, lot));
                            return {
                                burdenedAffectedTenure: {...burdenedAffectedTenure, affectedTenure: tenure, affectedTenureLot: lot},
                                selected: !!burdenedAffectedTenure
                            };
                        })
                    );
                } else {
                    const burdenedAffectedTenure = this.model.find(v => equals(v.affectedTenure, tenure) && !v.affectedTenureLot);
                    acc.push({
                        burdenedAffectedTenure: {...burdenedAffectedTenure, affectedTenure: tenure, affectedTenureLot: null},
                        selected: !!burdenedAffectedTenure
                    });
                }
                return acc;
            }, [])
        );
    }

    ngDoCheck(): void {
        const selectedBurdenedAffectedTenures = this.options.filter(o => o.selected).map(o => o.burdenedAffectedTenure);
        if (!equals(this.model, selectedBurdenedAffectedTenures)) {
            this.model.splice(0, this.model.length, ...selectedBurdenedAffectedTenures);
        }
    }

    allSelected() {
        return this.options.every(o => o.selected);
    }

    onSelectAll() {
        const selectAll = !this.allSelected();
        this.options.forEach(o => (o.selected = selectAll));
    }

    minSelected() {
        return this.options.some(o => o.selected);
    }

    getLotNumber(option: UiOption) {
        const lot = option.burdenedAffectedTenure.affectedTenureLot;
        if (!lot) {
            return '';
        }

        if (lot.nonLotCommonProperty) {
            return 'COMMON PROPERTY';
        }

        const lotSuffix = lot.parentLotType === 'CP' ? ` (${lot.parentLotType})` : '';
        return `${lot.parentLotPrefix || ''}${lot.parentLot || ''}${lotSuffix}`;
    }

    getTitleReference(option: UiOption) {
        return option.burdenedAffectedTenure.affectedTenureLot && option.burdenedAffectedTenure.affectedTenureLot.titles
            ? option.burdenedAffectedTenure.affectedTenureLot.titles.join()
            : option.burdenedAffectedTenure.affectedTenure.title;
    }

    getPlanType(option: UiOption) {
        const tenure = option.burdenedAffectedTenure.affectedTenure;
        const parentPlanTypeLookup = this.parentPlanTypeLookups.find(
            v => (v.code === 'NLOP' && (!tenure.lots || tenure.lots.length === 0)) || (tenure.parentPlanType && v.code === tenure.parentPlanType.code)
        );
        return parentPlanTypeLookup && parentPlanTypeLookup.name;
    }

    getPlanNumber(option: UiOption) {
        return option.burdenedAffectedTenure.affectedTenure.parentPlan;
    }

    getSubjectLandDescription(option: UiOption) {
        return option.burdenedAffectedTenure.affectedTenure.subjectLandDescription;
    }
}
